<template>
  <div :style="autoHeight" style="display: flex;" class="cab" @click="startTimer" @keyup="startTimer" @mouseup="startTimer" @mousemove="startTimer" @mousedown="startTimer">
<!--  <div class="cab" @click="startTimer" @keyup="startTimer" @mouseup="startTimer" @mousemove="startTimer" @mousedown="startTimer">-->
<!--    <el-scrollbar style="height: 100%;" ref="scrollbar">-->
      <div style="height: 100%;overflow-x: hidden;overflow-y: auto" >
<!--      <div style="height: 100%;" >-->
        <el-card >
          <div class="header-card" style="padding-bottom: 30px; border-bottom: 1px solid #EBEEF5; width: 100%" >
            <span style="float: left;color:#5ddddc;margin-right: 5px">|</span>
            <span style="font-weight: bolder;float: left;font-size: 16px">人员基本信息</span>
          </div>

          <div style="margin-top: 20px">
            <el-form :rules="rules" ref="ruleForm" :model="form">
              <el-row :gutter="20">
                <el-col :span="8" v-if="this.$route.query.flag == 'update'">
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name" type="text" placeholder="请输入用户姓名" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="this.$route.query.flag == 'update'">
                  <el-form-item label="手机号" prop="userId">
                    <el-input v-model="form.userId" type="text" placeholder="请输入手机号" clearable :disabled="isDisabledUserId"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="this.$route.query.flag == 'update'" >
                  <el-form-item label="所属机构" prop="majorDepartId">
                    <yl-cascader
                      :options="departments"
                      @change="handleDeptChange"
                      v-model="elementDeptId"
                      :show-all-levels="false"
                      filterable
                      style="width: 100%">
                    </yl-cascader>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="证件类型">
                    <el-select v-model="form.idTypeCode" placeholder="请选择证件类型" clearable style="width: 100%">
                      <el-option v-for="(item, index) in codes.idTypeCodes" :key="index" :label="item.cdDesc" :value="item.cd"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证件号码" prop="idNumber">
                    <el-input v-model="form.idNumber" type="text" placeholder="请输入身份证号码" clearable @change="getInfo(form.idNumber)"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="性别" >
                    <el-select v-model="form.gender" placeholder="请选择性别" clearable style="width: 100%">
                      <el-option label="男" value="1"></el-option>
                      <el-option label="女" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出生年月日" >
                    <!--                  <el-input v-if="getBirthday" type="text" :value="getBirthday" disabled></el-input>-->
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.birthDate" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="民族" >
                    <el-select v-model="form.ethnicityCode" placeholder="请选择民族" clearable style="width: 100%">
                      <el-option label="汉族" value="1"></el-option>
                      <el-option label="壮族" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="籍贯:">
                    <el-cascader
                      ref="codeCascader"
                      :options="codesTree"
                      popper-class="disableFirstLevel"
                      @change="handleCodeChange"
                      v-model="pCodeAndCCode"
                      placeholder="试试搜索：北京，或者选择"
                      clearable filterable
                      style="width:100%">
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="政治面貌">
                    <el-select v-model="form.politicalAppearanceCode" placeholder="请选择政治面貌" clearable style="width: 100%">
                      <el-option label="中共党员" value="0"></el-option>
                      <el-option label="共青团员" value="1"></el-option>
                      <el-option label="群众" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话（长号）" prop="telNumLong">
                    <el-input v-model="form.telNumLong" type="text" placeholder="请输入联系电话（长号）" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话（短号）" prop="telNumShort">
                    <el-input v-model="form.telNumShort" type="text" placeholder="请输入联系电话（短号）" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="邮箱" prop="email">
                    <el-input v-model="form.email" type="text" placeholder="请输入邮箱" clearable ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="工号" prop="workNumber">
                    <el-input v-model="form.workNumber" type="text" placeholder="请输入工号" clearable ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="科室" prop="section">
                    <el-input v-model="form.section" type="text" placeholder="请输入科室" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="当前科室职务" prop="currentSectionPosition">
                    <el-input v-model="form.currentSectionPosition" type="text" placeholder="请输入当前科室职务" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="来院时间" >
                    <el-date-picker v-model="form.hospitalDate" type="date" placeholder="请选择来院时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="工作时间" >
                    <el-date-picker v-model="form.workDate" type="date" placeholder="请选择工作时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学历" >
                    <el-select v-model="form.educationCode" placeholder="请选择学历" clearable style="width: 100%">
                      <el-option label="高中" value="1"></el-option>
                      <el-option label="专科" value="2"></el-option>
                      <el-option label="本科" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学位" >
                    <el-select v-model="form.degreeCode" placeholder="请选择学位" clearable style="width: 100%">
                      <el-option label="学士学位" value="1"></el-option>
                      <el-option label="硕士学位" value="2"></el-option>
                      <el-option label="博士学位" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="研究方向" prop="researchDirection">
                    <el-input v-model="form.researchDirection" type="text" placeholder="请输入研究方向" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="大学学校" prop="universitySchool">
                    <el-input v-model="form.universitySchool" type="text" placeholder="请输入大学学校" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="大学专业" prop="universityMajor">
                    <el-input v-model="form.universityMajor" type="text" placeholder="请输入大学专业" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="大学入读时间">
                    <el-date-picker v-model="form.universityAdmDate" type="date" placeholder="请选择大学入读时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="大学毕业时间" >
                    <el-date-picker v-model="form.universityGradDate" type="date" placeholder="请选择大学毕业时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="本科学校" prop="undergradSchool">
                    <el-input v-model="form.undergradSchool" type="text" placeholder="请输入本科学校" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="本科专业" prop="undergradMajor">
                    <el-input v-model="form.undergradMajor" type="text" placeholder="请输入本科专业" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="本科入读时间" >
                    <el-date-picker v-model="form.undergradAdmDate" type="date" placeholder="请选择本科入读时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="本科毕业时间" >
                    <el-date-picker v-model="form.undergradGradDate" type="date" placeholder="请选择本科毕业时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="硕士学校" prop="masterSchool">
                    <el-input v-model="form.masterSchool" type="text" placeholder="请输入硕士学校" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="硕士专业" prop="masterMajor">
                    <el-input v-model="form.masterMajor" type="text" placeholder="请输入硕士专业" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="硕士入读时间">
                    <el-date-picker v-model="form.masterAdmDate" type="date" placeholder="请选择硕士入读时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="硕士毕业时间" >
                    <el-date-picker v-model="form.masterGradDate" type="date" placeholder="请选择硕士毕业时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="硕士导师姓名" prop="masterTutorName">
                    <el-input v-model="form.masterTutorName" type="text" placeholder="请输入硕士导师姓名" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士学校" prop="phdSchool">
                    <el-input v-model="form.phdSchool" type="text" placeholder="请输入博士学校" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士专业" prop="phdMajor">
                    <el-input v-model="form.phdMajor" type="text" placeholder="请输入博士专业" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士入读时间" >
                    <el-date-picker v-model="form.phdAdmDate" type="date" placeholder="请选择博士入读时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士毕业时间" >
                    <el-date-picker v-model="form.phdGradDate" type="date" placeholder="请选择博士毕业时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士导师姓名" prop="phdTutorName">
                    <el-input v-model="form.phdTutorName" type="text" placeholder="请输入博士导师姓名" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士后学校" prop="postDoctoralSchool">
                    <el-input v-model="form.postDoctoralSchool" type="text" placeholder="请输入博士后学校" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士后专业" prop="postDoctoralMajor">
                    <el-input v-model="form.postDoctoralMajor" type="text" placeholder="请输入博士后专业" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士后入读时间" >
                    <el-date-picker v-model="form.postDoctoralAdmDate" type="date" placeholder="请选择博士后入读时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士后毕业时间" >
                    <el-date-picker v-model="form.postDoctoralGradDate" type="date" placeholder="请选择博士后毕业时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="博士后导师姓名" prop="postDoctoralTutorName">
                    <el-input v-model="form.postDoctoralTutorName" type="text" placeholder="请输入博士后导师姓名" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学科级别" prop="disciplineLevel">
                    <el-input v-model="form.disciplineLevel" type="text" placeholder="请输入学科级别" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否学科带头人" >
                    <el-select v-model="form.isDisciplineLeader" placeholder="请选择是否学科带头人" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否学术带头人" >
                    <el-select v-model="form.isAcademicLeader" placeholder="请选择是否学术带头人" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="现职称等级">
                    <el-select v-model="form.currentTitleLevelCode" placeholder="请选择现职称等级" clearable style="width: 100%">
                      <el-option label="等级1" value="1"></el-option>
                      <el-option label="等级2" value="2"></el-option>
                      <el-option label="等级3" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="中级专业技术资格证时间">
                    <el-date-picker v-model="form.imdProQualDate" type="date" placeholder="请选择中级专业技术资格证时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="中级专业技术资格证专业名称">
                    <el-input v-model="form.imdProQualName" type="text" placeholder="请输入中级专业技术资格证专业名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="中级专业技术资格证资格级别">
                    <el-select v-model="form.imdProQualLevelCode" placeholder="请选择中级专业技术资格证资格级别" clearable style="width: 100%">
                      <el-option label="级别一" value="1"></el-option>
                      <el-option label="级别二" value="2"></el-option>
                      <el-option label="级别三" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="副高级专业技术资格证时间">
                    <el-date-picker v-model="form.ascSnrProQualDate" type="date" placeholder="请输入副高级专业技术资格证时间" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="副高级专业技术资格评审委员会">
                    <el-input v-model="form.ascSnrProQualJury" type="text" placeholder="请输入副高级专业技术资格评审委员会" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="副高级专业技术资格证专业名称">
                    <el-input v-model="form.ascSnrProQualName" type="text" placeholder="请输入副高级专业技术资格证专业名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="副高级专业技术任职资格名称">
                    <el-input v-model="form.ascSnrProQualApptName" type="text" placeholder="请输入副高级专业技术任职资格名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="副高级专业技术资格证编号">
                    <el-select v-model="form.ascSnrProQualLicCode" placeholder="请选择副高级专业技术资格证编号" clearable style="width: 100%">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="正高级专业技术资格证时间">
                    <el-date-picker v-model="form.posSnrProQualDate" type="date" placeholder="请输入正高级专业技术资格证时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="正高级专业技术资格评审委员会">
                    <el-input v-model="form.posSnrProQualJury" type="text" placeholder="请输入正高级专业技术资格评审委员会" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="正高级专业技术资格证专业名称">
                    <el-input v-model="form.posSnrProQualName" type="text" placeholder="请输入正高级专业技术资格证专业名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="正高级专业技术任职资格名称">
                    <el-input v-model="form.posSnrProQualApptName" type="text" placeholder="请输入正高级专业技术任职资格名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="正高级专业技术资格证编号">
                    <el-select v-model="form.posSnrProQualLicCode" placeholder="请选择正高级专业技术资格证编号" clearable style="width: 100%;">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否有教师资格">
                    <el-select v-model="form.teacherQual" placeholder="请选择是否有教师资格" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.teacherQual == '1'">
                  <el-form-item label="教师资格种类">
                    <el-select v-model="form.teacherQualTypeCode" placeholder="请选择教师资格种类" clearable style="width: 100%">
                      <el-option label="种类一" value="1"></el-option>
                      <el-option label="种类二" value="2"></el-option>
                      <el-option label="种类三" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.teacherQual == '1'">
                  <el-form-item label="教师证书编号">
                    <el-select v-model="form.teacherLicCode" placeholder="请选择教师证书编号" clearable style="width: 100%;">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.teacherQual == '1'">
                  <el-form-item label="教师证书获得时间">
                    <el-date-picker v-model="form.teacherLicDate" type="date" placeholder="请输入教师证书获得时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否有讲师资格">
                    <el-select v-model="form.lecturerQual" placeholder="请选择是否有讲师资格" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.lecturerQual == '1'">
                  <el-form-item label="讲师证书获得时间">
                    <el-date-picker v-model="form.lecturerLicDate" type="date" placeholder="请输入讲师证书获得时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.lecturerQual == '1'">
                  <el-form-item label="讲师证书名称">
                    <el-input v-model="form.lecturerLicName" type="text" placeholder="请输入讲师证书名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.lecturerQual == '1'">
                  <el-form-item label="讲师证书编号">
                    <el-select v-model="form.lecturerLicCode" type="text" placeholder="请选择讲师证书编号" clearable style="width: 100%">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否有副教授资格">
                    <el-select v-model="form.ascProfessor" type="text" placeholder="请输入是否有副教授资格" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.ascProfessor == '1'">
                  <el-form-item label="副教授专业技术资格证发证时间">
                    <el-date-picker v-model="form.ascProfessorLicDate" type="date" placeholder="请输入副教授专业技术资格证发证时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.ascProfessor == '1'">
                  <el-form-item label="副教授专业技术资格专业名称">
                    <el-input v-model="form.ascProfessorLicName" type="text" placeholder="请输入副教授专业技术资格专业名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.ascProfessor == '1'">
                  <el-form-item label="副教授专业技术资格证编号">
                    <el-select v-model="form.ascProfessorLicCode" placeholder="请选择副教授专业技术资格证编号" clearable style="width: 100%">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否有教授资格">
                    <el-select v-model="form.professor" placeholder="请选择是否有教授资格" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.professor == '1'">
                  <el-form-item label="教授专业技术资格证发证时间">
                    <el-date-picker v-model="form.professorLicDate" type="date" placeholder="请选择教授专业技术资格证发证时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.professor == '1'">
                  <el-form-item label="教授资格评审委员会">
                    <el-input v-model="form.professorQualJury" type="text" placeholder="请输入教授资格评审委员会" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.professor == '1'">
                  <el-form-item label="教授专业技术资格专业名称">
                    <el-input v-model="form.professorLicName" type="text" placeholder="请输入教授专业技术资格专业名称" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.professor == '1'">
                  <el-form-item label="教授专业技术资格证编号">
                    <el-select v-model="form.professorLicCode" placeholder="请选择教授专业技术资格证编号" clearable style="width: 100%;">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否硕士导师">
                    <el-select v-model="form.masterInstructor" placeholder="请选择是否硕士导师" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.masterInstructor == '1'">
                  <el-form-item label="硕士导师获得时间">
                    <el-date-picker v-model="form.masterInstructorDate" type="date" placeholder="请选择硕士导师获得时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.masterInstructor == '1'">
                  <el-form-item label="是否博士导师">
                    <el-select v-model="form.doctorInstructor" placeholder="请选择是否博士导师" clearable style="width: 100%;">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.masterInstructor == '1'">
                  <el-form-item label="博士导师获得时间">
                    <el-date-picker v-model="form.doctorInstructorDate" type="date" placeholder="请选择博士导师获得时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="是否拥有GCP证">
                    <el-select v-model="form.gcp" placeholder="请选择是否拥有GCP证" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="form.gcp == '1'">
                  <el-form-item label="GCP证获得时间">
                    <el-date-picker v-model="form.gcpDate" type="date" placeholder="请选择GCP证获得时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>

        <el-card style="margin-top: 10px">
          <div class="header-card" style="padding-bottom: 30px; border-bottom: 1px solid #EBEEF5; width: 100%" >
            <span style="font-weight: bolder;float: left;font-size: 16px">执业资格信息</span>
          </div>

          <div style="margin-top: 10px">
            <el-form >
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="是否有执业资格" v-if="form.practiceQual != 1">
                    <el-select v-model="form.practiceQual" placeholder="请选择是否有执业资格" clearable>
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40" v-if="form.practiceQual == 1">
                <el-col :span="8">
                  <el-form-item label="是否有执业资格">
                    <el-select v-model="form.practiceQual" placeholder="请选择是否有执业资格" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="执业证发证时间">
                    <el-date-picker v-model="form.practiceLicTime" type="date" placeholder="请选择执业证发证时间" style="width: 100%">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="执 业 证 编 码  ">
                    <el-select v-model="form.practiceLicCode" placeholder="请选择执业证编码" clearable style="width: 100%">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="执业证执业类别">
                    <el-select v-model="form.practiceLicTypeCode" placeholder="请选择执业证执业类别" clearable style="width: 100%">
                      <el-option label="类别1" value="1"></el-option>
                      <el-option label="类别2" value="2"></el-option>
                      <el-option label="类别3" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="执业证执业范围">
                    <el-select v-model="form.practiceLicScopeCode" placeholder="请选择执业证执业范围" clearable style="width: 100%">
                      <el-option label="范围1" value="1"></el-option>
                      <el-option label="范围2" value="2"></el-option>
                      <el-option label="范围3" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                    <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">上传附件</div>
                    <el-upload
                      style="height: 40%"
                      v-if="attachment.opt"
                      class="upload-demo"
                      drag
                      action
                      multiple
                      :show-file-list="false"
                      fullscreen="true"
                      :before-remove="beforeRemove"
                      :http-request="practiceQualUpload"
                      :accept="acceptAttachmentType"
                      :before-upload='handleBeforeUpload'>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em></div>
                    </el-upload>
                    <el-scrollbar style="height: 270px" ref="scrollbar">
                      <div style="width: calc(100% - 20px)">
                        <el-table :data="fileDialog.practiceQualAttachs.tableDataList" border size="small">
                          <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                          <el-table-column align="center" prop="attachmentName" label="文件别名" >
                            <template slot-scope="scope">
                              <el-input :placeholder="'输入别名'" class="text-input"  v-model="scope.row.attachmentName"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column align="center" prop="" label="操作" width="100">
                            <template slot-scope="scope">
                              <!--查看附件-->
                              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.practiceQualAttachs.cd)"></el-button>
                              <!--移除附件-->
                              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-close" @click="beforeRemove(scope.row, scope.$index, fileDialog.practiceQualAttachs.cd)" v-if="attachment.editedFlag"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-scrollbar>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>

        <el-card style="margin-top: 10px">
          <div class="header-card" style="padding-bottom: 30px; border-bottom: 1px solid #EBEEF5; width: 100%" >
            <span style="font-weight: bolder;float: left;font-size: 16px">医师资格信息</span>
          </div>
          <div style="margin-top: 10px">
            <el-form>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="是否拥有医师资格" v-if="form.medicalQual != 1" style="margin-bottom: 0px">
                    <el-select v-model="form.medicalQual" placeholder="请选择是否拥有医师资格" clearable>
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40" v-if="form.medicalQual == '1'">
                <el-col :span="8">
                  <el-form-item label="是否拥有医师资格">
                    <el-select v-model="form.medicalQual" placeholder="请选择是否拥有医师资格" clearable style="width: 100%">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="医师资格证发证时间">
                    <el-date-picker v-model="form.medicalLicTime" type="date" placeholder="请选择医师资格证发证时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="医师证编码">
                    <el-select v-model="form.medicalLicCode" placeholder="请选择医师证编码" clearable style="width: 100%">
                      <el-option label="001" value="1"></el-option>
                      <el-option label="002" value="2"></el-option>
                      <el-option label="003" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="医师证专业">
                    <el-select v-model="form.medicalLicSpecialtyCode" placeholder="请选择医师证专业" clearable style="width: 100%">
                      <el-option label="专业1" value="1"></el-option>
                      <el-option label="专业2" value="2"></el-option>
                      <el-option label="专业3" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="医师证类别">
                    <el-select v-model="form.medicalLicTypeCode" placeholder="请选择医师证类别" clearable style="width: 100%;">
                      <el-option label="类别1" value="1"></el-option>
                      <el-option label="类别2" value="2"></el-option>
                      <el-option label="类别3" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                    <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">上传附件</div>
                    <el-upload
                      style="height: 40%"
                      v-if="attachment.opt"
                      class="upload-demo"
                      drag
                      action
                      multiple
                      :show-file-list="false"
                      fullscreen="true"
                      :before-remove="beforeRemove"
                      :http-request="medicalQualUpload"
                      :accept="acceptAttachmentType"
                      :before-upload='handleBeforeUpload'>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em></div>
                    </el-upload>
                    <el-scrollbar style="height: 270px" ref="scrollbar">
                      <div style="width: calc(100% - 20px)">
                        <el-table :data="fileDialog.medicalLicAttachs.tableDataList" border size="small">
                          <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                          <el-table-column align="center" prop="attachmentName" label="文件别名" >
                            <template slot-scope="scope">
                              <el-input :placeholder="'输入别名'" class="text-input"  v-model="scope.row.attachmentName"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column align="center" prop="" label="操作" width="100">
                            <template slot-scope="scope">
                              <!--查看附件-->
                              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.medicalLicAttachs.cd)"></el-button>
                              <!--移除附件-->
                              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-close" @click="beforeRemove(scope.row, scope.$index, fileDialog.medicalLicAttachs.cd)" v-if="attachment.editedFlag"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-scrollbar>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>

        <el-card style="margin-top: 10px">
          <div class="header-card" style="padding-bottom: 30px; border-bottom: 1px solid #EBEEF5; width: 100%" >
            <span style="font-weight: bolder;float: left;font-size: 16px">初级专业技术资格信息</span>
          </div>
          <div style="margin-top: 10px">
            <el-form>
              <el-row :gutter="40">
                <el-col :span="8">
                  <el-form-item label="初级专业技术资格证时间">
                    <el-date-picker v-model="form.juniorProQualDate" type="date" placeholder="请选择初级专业技术资格证时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="初级专业技术资格证专业名称">
                    <el-input v-model="form.juniorProQualName" type="text" placeholder="请输入初级专业技术资格证专业名称" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="初级专业技术资格证资格级别">
                    <el-select v-model="form.juniorProQualLevelCode" placeholder="请输入初级专业技术资格证资格级别" clearable style="width: 100%">
                      <el-option label="级别一" value="1"></el-option>
                      <el-option label="级别二" value="2"></el-option>
                      <el-option label="级别三" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                    <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">上传附件</div>
                    <el-upload
                      style="height: 40%"
                      v-if="attachment.opt"
                      class="upload-demo"
                      drag
                      action
                      multiple
                      :show-file-list="false"
                      fullscreen="true"
                      :before-remove="beforeRemove"
                      :http-request="juniorProQualUpload"
                      :accept="acceptAttachmentType"
                      :before-upload='handleBeforeUpload'>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em></div>
                    </el-upload>
                    <el-scrollbar style="height: 270px" ref="scrollbar">
                      <div style="width: calc(100% - 20px)">
                        <el-table :data="fileDialog.juniorProQualAttachs.tableDataList" border size="small">
                          <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                          <el-table-column align="center" prop="attachmentName" label="文件别名" >
                            <template slot-scope="scope">
                              <el-input :placeholder="'输入别名'" class="text-input"  v-model="scope.row.attachmentName"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column align="center" prop="" label="操作" width="100">
                            <template slot-scope="scope">
                              <!--查看附件-->
                              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.juniorProQualAttachs.cd)"></el-button>
                              <!--移除附件-->
                              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-close" @click="beforeRemove(scope.row, scope.$index, fileDialog.juniorProQualAttachs.cd)" v-if="attachment.editedFlag"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-scrollbar>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>


        </el-card>
      </div>


<!--    </el-scrollbar>-->
    <div class="demo-image__preview">
      <el-image
        ref="previewImg"
        :preview-src-list="attachment.attachmentsLink">
      </el-image>
    </div>
    <animation :loadingDataVisible="!attachmentUploadState || !formInfoSaveState" :loadingText="loadingText"></animation>
  </div>
</template>

<script>
  import http from "@/utils/axios";
  import cookie from "@/utils/cookie";
  import {mapState} from "vuex";
  import {Message} from "element-ui";
  import * as constantsRules from '@/constants/constantRules';
  import {getCascaderFullValue} from '@/utils/cascader';
  import {CARD_HEIGHT_TYPE, ATTA_UPLOAD_COMPONENT_TYPE_STR,
          ATTA_FILE_SUF_LIST, ATTA_FILE_SHOW_TYPE, ATTA_FILE_DOWN_TYPE} from '@/constants/constants';
  import BasicInfoDetail from "./BasicInfoDetail";
  import animation from '@/components/loading/animation'

  export default {
    name: "BasicUpdateInfo",
    components: {BasicInfoDetail,animation},
    data() {
      return {
        elementDeptId:[],
        //附件的允许上传的类型
        acceptAttachmentType: ATTA_UPLOAD_COMPONENT_TYPE_STR,
        //true是结束,false是正在处理
        attachmentUploadState:true,
        //true是结束,false是正在处理
        formInfoSaveState:true,
        loadingText:null,
        activeNames: ['1'],
        form: {
          name: '',
          userId: '',
          majorDepartId: '',
          ethnicityCode: '',
          gender: '',
          birthDate: '',
          idTypeCode: '',
          idNumber: '',
          originProvinceCode: '',
          originCityCode: '',
          politicalAppearanceCode: '',
          telNumLong: '',
          telNumShort: '',
          email: '',
          workNumber: '',
          section: '',
          currentSectionPosition: '',
          hospitalDate: '',
          workDate: '',
          educationCode: '',
          degreeCode: '',
          disciplineLevel: '',
          researchDirection: '',
          universitySchool: '',
          universityMajor: '',
          universityAdmDate: '',
          universityGradDate: '',
          undergradSchool: '',
          undergradMajor: '',
          undergradAdmDate: '',
          undergradGradDate: '',
          masterSchool: '',
          masterMajor: '',
          masterAdmDate: '',
          masterGradDate: '',
          masterTutorName: '',
          phdSchool: '',
          phdMajor: '',
          phdAdmDate: '',
          phdGradDate: '',
          phdTutorName: '',
          postDoctoralSchool: '',
          postDoctoralMajor: '',
          postDoctoralAdmDate: '',
          postDoctoralGradDate: '',
          postDoctoralTutorName: '',
          isDisciplineLeader: '',
          isAcademicLeader: '',
          practiceQual: '',
          practiceLicTime: '',
          practiceLicCode: '',
          practiceLicTypeCode: '',
          practiceLicScopeCode: '',
          medicalQual: '',
          medicalLicTime: '',
          medicalLicCode: '',
          medicalLicSpecialtyCode: '',
          medicalLicTypeCode: '',
          currentTitleLevelCode: '',
          juniorProQualDate: '',
          juniorProQualName: '',
          juniorProQualLevelCode: '',
          imdProQualDate: '',
          imdProQualName: '',
          imdProQualLevelCode: '',
          ascSnrProQualDate: '',
          ascSnrProQualJury: '',
          ascSnrProQualName: '',
          ascSnrProQualApptName: '',
          ascSnrProQualLicCode: '',
          posSnrProQualDate: '',
          posSnrProQualJury: '',
          posSnrProQualName: '',
          posSnrProQualApptName: '',
          posSnrProQualLicCode: '',
          teacherQual: '',
          teacherQualTypeCode: '',
          teacherLicCode: '',
          teacherLicDate: '',
          lecturerQual: '',
          lecturerLicDate: '',
          lecturerLicName: '',
          lecturerLicCode: '',
          ascProfessor: '',
          ascProfessorLicDate: '',
          ascProfessorLicName: '',
          ascProfessorLicCode: '',
          professor: '',
          professorLicDate: '',
          professorQualJury: '',
          professorLicName: '',
          professorLicCode: '',
          masterInstructor: '',
          masterInstructorDate: '',
          doctorInstructor: '',
          doctorInstructorDate: '',
          gcp: '',
          gcpDate: '',
          //附件列表
          practiceQualAttachs: [],
          medicalLicAttachs:[],
          juniorProQualAttachs:[],
        },
        //码表
        codes: {
          idTypeCodes: [], //证件类型码表数组
        },
        attachment:{
          //附件上传框 是否可见
          opt:true,
          editedFlag: true,
          attachmentsLink:[],
          //图片的类型后缀
          imagesType:['jpg','jpeg','png','gif'],
        },
        fileDialog:{
          practiceQualAttachs:{
            attachmentName:'',
            cd:'001-001',
            //真实的附件信息,没有id的,只是附件的二进制文件 的数组
            fileList: [],
            //附件的名字而已,别名 code id...  的数组
            tableDataList:[],
          },
          medicalLicAttachs:{
            attachmentName:'',
            cd:'001-036',
            fileList: [],
            tableDataList:[],
          },
          juniorProQualAttachs:{
            attachmentName:'',
            cd:'001-037',
            fileList: [],
            tableDataList:[],
          },
        },
        fileFlag:{
          attaFileSuf:ATTA_FILE_SUF_LIST,
          attaFileType:ATTA_FILE_SHOW_TYPE,
          attaFileDownType:ATTA_FILE_DOWN_TYPE,
          drawerVisible: false,
          fileSaveBtnLoading: false,
          updateFlag:false,
          uploadLoading:false,
        },
        autoHeight: {
          height: ''
        },
        departments: [],  //部门数组
        timeOut: '',   //定时器
        isDisabledUserId: false,   //是否禁用userId
        pCodeAndCCode: [],
        rules: constantsRules.BasicInfoRules,
        editSelf:'0',
      }
    },

    mounted() {
      //若是新增或者修改页面，就启用定时器
      if (this.$route.query.flag == "add" || this.$route.query.flag == 'update'){
        this.startTimer();
        this.handleScroll();
      }

      //userModule中的userId有值，就禁用输入框
      if (this.userUserId){
        this.isDisabledUserId = true;
      }

      //获取省份码表值
      this.handlePCodeAndCCode();
      //获取证件类型表值
      this.handleIdTypeCodes();
    },

    beforeDestroy() {
      let that = this;
      that.$once('hook:beforeDestroy',() =>{
        clearInterval(that.timeOut)
      })
    },

    methods: {
      //设置自适应高度
      getHeight() {
        this.autoHeight.height = (window.innerHeight- CARD_HEIGHT_TYPE - 20) + 'px';
      },

      //滚动条绑定定时器
      handleScroll() {
        let scrollbarEl = this.$refs.scrollbar.wrap
        scrollbarEl.onscroll = () => {
          this.startTimer();
        }
      },

      //页面5分钟无操作时自动调用接口
      startTimer() {
        let that = this;
        clearInterval(that.timeOut);
        that.timeOut = setInterval(()=>{
          that.handleCommitClick("auto");
        },5*60*1000)
      },

      //查询部门id
      getDepartments(){
        let token = cookie.getCookie("token");
        http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', {
          token: token,
          data: {
            pageSize: -1
          }
        }).then(response => {
          this.departments = response.data.data.departments;
          //计算出医院的全id路径
          if (this.form.majorDepartId){
            let departIds = getCascaderFullValue(this.departments,this.form.majorDepartId);
            this.elementDeptId=departIds
          }
        })
      },

      //拿到选择框选择的部门id
      handleDeptChange(value) {
          if(value != null){
            this.elementDeptId = value;
            this.form.majorDepartId = value[value.length -1]
        }
      },

      //拿到省份码表值
      handleCodeChange(value){
        if (value && value.length>0){
          this.$refs.codeCascader.dropDownVisible = false
          this.form.originProvinceCode = value[0]
          this.form.originCityCode = value.length>1?value[1]:'';
        }else {
          this.form.originProvinceCode = '';
          this.form.originCityCode = '';
        }
      },

      //获取籍贯的回显值
      handlePCodeAndCCode() {
        let result = [];
        if (this.form.originCityCode){
          result.push(this.form.originProvinceCode)
          result.push(this.form.originCityCode)
        } else {
          result.push(this.form.originProvinceCode)
        }
        this.pCodeAndCCode = result;
      },

      //获取证件类型回显值
      handleIdTypeCodes(){
        if(this.eimsCodes.length > 0){
          this.eimsCodes.forEach(arr => {
            if(arr.tp=='007'){
              this.codes.idTypeCodes.push(arr);
            }
          })
        }
      },

      //根据身份证自动获取出生日期和性别
      getInfo(idCard) {
        if (this.form.idTypeCode == '007-001'){
          let sex = null;
          let birth = null;
          let myDate = new Date();
          let month = myDate.getMonth() + 1;
          let day = myDate.getDate();

          if(idCard.length===18){
            sex = idCard.substring(16,17);
            birth = idCard.substring(6,10)+"-"+idCard.substring(10,12)+"-"+idCard.substring(12,14);
            if (idCard.substring(10, 12) < month || idCard.substring(10, 12) === month && idCard.substring(12, 14) <= day);
          }else if(idCard.length===15){
            sex = idCard.substring(13,14);
            birth = "19"+idCard.substring(6,8)+"-"+idCard.substring(8,10)+"-"+idCard.substring(10,12);
            if (idCard.substring(8, 10) < month || idCard.substring(8, 10) === month && idCard.substring(10, 12) <= day);
          }else {
            return;
          }
          if(sex%2 === 0){
            sex = '0';  // 1代表男，0代表女
          }
          else{
            sex = '1';
          }
          this.form.birthDate = birth;
          this.form.gender = sex;
        }
      },

      //提交操作的数据
      handleCommitClick(param){
        //将页面信息存到modules中
        let that = this;
        let eimsUser = {
          userId: that.form.userId,
          name: that.form.name,
          //这个是为了保存到数据库使用的
          majorDepartId: that.elementDeptId[that.elementDeptId.length - 1] || this.form.majorDepartId,
          //这个是为了回显组件数据使用的
          elementDeptId: that.elementDeptId,
          practiceQualAttachs: that.form.practiceQualAttachs,
          medicalLicAttachs: that.form.medicalLicAttachs,
          juniorProQualAttachs: that.form.juniorProQualAttachs,
        }
        this.$store.dispatch("getBasicInfo", {"eimsUser": eimsUser, "eimsUserInfoBase": that.form});
        //规则校验
        // if (this.$route.query.isSelf && this.$route.query.flag == "update"){
        //   if (!that.validateFileForm()){
        //     return true;
        //   }
        // }else {
        //
        // }
        if (!that.validateFileForm()) {
          return false;
        }
        //提交数据
        let flag = 'UPDATE';
        let editSelf = this.editSelf;
        //如果userModule中的userId有值，则创建用户变成修改用户
        // if(that.userUserId){
        //   flag = "UPDATE"
        // }

        //userModule中的userId没有值或者userModule中userId值等于输入框中的userId值，方可调用接口
        if (!that.userUserId || that.userUserId == that.form.userId){
          that.$store.dispatch("updateOrInsertMemberInfo",{flag,editSelf}).then(value => {
            if(value.data.code == '00000'){
              if (this.$route.query.flag == "add"){
                Message.success({message:"创建用户成功", showClose: true});
              }else if(this.$route.query.flag == "update"){
                Message.success({message:"修改用户成功", showClose: true});
              }
              if (param != "auto"){
                this.$router.push({path:'/user/list'});
              }
              this.$store.dispatch("getEimsUser",{"userId": this.userId})
            }
          })
        }
      },

      //规则校验
      validateFileForm() {
          let result = false;
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              result = true;
            }

          })
          return result;
        },

      //取消返回成员列表页面
      handleCancelClick() {
        if (this.$route.query.path == '/user/approve') {
          this.$router.push({path:'/user/approve'});
        }else {
          this.$router.push({path:'/user/list'});
        }
      },

      //跳转到下一个页面
      goNextPageClick() {
        let that = this;
          if (!that.validateFileForm()){
            return false;
        }
        let data='/user/info/paper'   //要传的值
        //子路由通过$emit触发父级路由中的方法
        this.$emit('childClick',data)
      },

      //保存附件信息到form中
      saveAttachs(flag){
        let that = this;
        let attachments =[];
        let updateAttachments = [];
        if (flag == '001-001'){
          attachments = that.fileDialog.practiceQualAttachs.tableDataList;
          //筛选出id不为null的文件的数据
          for (let attachment of attachments){
            if (attachment.id !=null){
              updateAttachments.push(attachment)
            }
          }
          that.form.practiceQualAttachs= updateAttachments;
        }else if(flag == '001-036'){
          attachments = that.fileDialog.medicalLicAttachs.tableDataList;
          //筛选出id不为null的文件的数据
          for (let attachment of attachments){
            if (attachment.id !=null){
              updateAttachments.push(attachment)
            }
          }
          that.form.medicalLicAttachs= updateAttachments;
        }
        else if(flag == '001-037'){
          attachments = that.fileDialog.juniorProQualAttachs.tableDataList;
          //筛选出id不为null的文件的数据
          for (let attachment of attachments){
            if (attachment.id !=null){
              updateAttachments.push(attachment)
            }
          }
          that.form.juniorProQualAttachs= updateAttachments;
        }
      },

      //将页面信息保存到moudles中
      handleCommit(){
        let that = this;
        let eimsUser = {
          userId: that.form.userId,
          name: that.form.name,
          //这个是为了保存到数据库使用的
          majorDepartId: that.elementDeptId[that.elementDeptId.length - 1] || that.form.majorDepartId,
          //这个是为了回显组件数据使用的
          elementDeptId: that.elementDeptId,
          practiceQualAttachs: that.form.practiceQualAttachs,
          medicalLicAttachs: that.form.medicalLicAttachs,
          juniorProQualAttachs: that.form.juniorProQualAttachs,
        }

        that.$store.dispatch("getBasicInfo", {"eimsUser": eimsUser, "eimsUserInfoBase": that.form});

        let editSelf = that.editSelf
        let flag = 'UPDATE';
        if (!that.userUserId || that.userUserId == that.form.userId){
          that.$store.dispatch("updateOrInsertMemberInfo",{flag,editSelf}).then(value => {
            if(value.data.code == '00000'){
              if (that.$route.query.flag == "add"){
                Message.success({message:"创建用户成功", showClose: true});
              }else if(that.$route.query.flag == "update"){
                Message.success({message:"修改用户成功", showClose: true});
              }
              if (that.$route.query.isSelf && that.$route.query.flag == "update"){
                that.$router.push({path: '/myself/info/update'})
              } else{
                that.$router.push({path:'/user/list'});
              }
              that.$store.dispatch("getEimsUser",{"userId": that.userId})
            }

          })
        }
        that.formInfoSaveState = true
        that.attachmentUploadState = true;
      },

      //fileDialog方法
      fileUpload(file, fileList, flag) {
        if (file.file.size > this.singleAttachmentSize){
          Message.error("上传的附件大小不能大于10MB")
          return
        }
        //由于组件可能存在问题 ,直接共用一个list会出现选择文件之后文件列表不显示文件名的情况
        //所以需要定义两个,一个用于显示文件名,一个用于接受文件
        if (flag == "001-001"){
          this.fileDialog.practiceQualAttachs.fileList.push(file);
          //设置文件的原名
          this.fileDialog.practiceQualAttachs.tableDataList.push({
            attachmentOriginalName:file.file.name
          })
        }else if (flag == '001-036'){
          this.fileDialog.medicalLicAttachs.fileList.push(file);
          //设置文件的原名
          this.fileDialog.medicalLicAttachs.tableDataList.push({
            attachmentOriginalName:file.file.name
          })
        }else if (flag == '001-037'){
          this.fileDialog.juniorProQualAttachs.fileList.push(file);
          //设置文件的原名
          this.fileDialog.juniorProQualAttachs.tableDataList.push({
            attachmentOriginalName:file.file.name
          })
        }
      },

      practiceQualUpload(file, fileList){
        this.fileUpload(file, fileList, this.fileDialog.practiceQualAttachs.cd);
      },

      medicalQualUpload(file, fileList){
        this.fileUpload(file, fileList, this.fileDialog.medicalLicAttachs.cd);
      },

      juniorProQualUpload(file, fileList){
        this.fileUpload(file, fileList, this.fileDialog.juniorProQualAttachs.cd);
      },

      // 上传之前判断类型
      handleBeforeUpload(file) {
        let testMsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (!this.fileFlag.attaFileSuf.includes(testMsg)) {
          this.$message({
            message: '上传附件类型不合法！',
            type: 'warning',
            showClose:true
          })
          return false
        } else {
          return true
        }
      },

      //点击移除按钮的时候提执行
      beforeRemove(item,idx,flag) {
        let oldData = [];
        let tableDataList = [];
        let fileList = [];
        if(flag == '001-001'){
          tableDataList = this.fileDialog.practiceQualAttachs.tableDataList;
          fileList = this.fileDialog.practiceQualAttachs.fileList;
        }else if(flag == '001-036'){
          tableDataList = this.fileDialog.medicalLicAttachs.tableDataList;
          fileList = this.fileDialog.medicalLicAttachs.fileList;
        }else if(flag == '001-037'){
          tableDataList = this.fileDialog.juniorProQualAttachs.tableDataList;
          fileList = this.fileDialog.juniorProQualAttachs.fileList;
        }
        for (let item of tableDataList){
          if(item.id){
            oldData.push(item);
          }
        }

        let index = tableDataList.length - oldData.length
        tableDataList.splice(idx,1);
        if (index === 0){
          //代表没有新加的文件
          fileList.splice(idx,1)
        }else {
          //old 4  new 2  count 6 remove 最后一个(count(index) = 5 , removeIndex(index) = 1)
          //old 4  new 3  count 7 remove 倒数第二个(count(index) = 5 , removeIndex(index) = 1)
          //old 4  new 4  count 8 remove 倒数第三个(count(index) = 5 , removeIndex(index) = 1)
          // let removeIndex = count - old - (count - idx )
          //7-4-(7-5)
          // let removeIndex = this.fileDialog.tableDataList.length - oldData.length - ( this.fileDialog.tableDataList.length - idx)
          //化简
          let removeIndex = idx - oldData.length
          //负数的索引会重最后一个对象开始删起
          if(removeIndex >= 0){
            fileList.splice(removeIndex,1)
          }
        }
      },

      //上传执业证附件信息
      savePracticeDeptByFile() {
        if (this.fileDialog.practiceQualAttachs.fileList.length === 0) {
          // Message.error({message: "请先选择上传的文件", showClose: true});
          this.saveAttachs(this.fileDialog.practiceQualAttachs.cd);
          this.saveMedicalDeptByFile();
          return
        }
        let attachment = [];
        // this.loadingText="上传中"
        let start=this.fileDialog.practiceQualAttachs.tableDataList.length - this.fileDialog.practiceQualAttachs.fileList.length
        let end = this.fileDialog.practiceQualAttachs.tableDataList.length
        //只需要上传新的数据即可
        for (let i= start ;i<end ;i++){
          attachment.push({
            attachmentName : this.fileDialog.practiceQualAttachs.tableDataList[i].attachmentName,
            attachmentOriginalName : this.fileDialog.practiceQualAttachs.tableDataList[i].attachmentOriginalName,
          })
        }
        //上传附件
        this.uploadFiles(attachment, this.fileDialog.practiceQualAttachs.tableDataList, this.fileDialog.practiceQualAttachs.cd)
      },

      //上传医师证附件信息
      saveMedicalDeptByFile() {
        if (this.fileDialog.medicalLicAttachs.fileList.length === 0) {
          // Message.error({message: "请先选择上传的文件", showClose: true});
          this.saveAttachs(this.fileDialog.medicalLicAttachs.cd);
          this.savejuniorProDeptByFile()
          return;
        }
        let attachment = [];
        // this.loadingText="上传中"
        let start=this.fileDialog.medicalLicAttachs.tableDataList.length - this.fileDialog.medicalLicAttachs.fileList.length
        let end = this.fileDialog.medicalLicAttachs.tableDataList.length
        //只需要上传新的数据即可
        for (let i= start ;i<end ;i++){
          attachment.push({
            attachmentName : this.fileDialog.medicalLicAttachs.tableDataList[i].attachmentName,
            attachmentOriginalName : this.fileDialog.medicalLicAttachs.tableDataList[i].attachmentOriginalName,
          })
        }
        //上传附件
        this.uploadFiles(attachment, this.fileDialog.medicalLicAttachs.tableDataList, this.fileDialog.medicalLicAttachs.cd)
      },

      //上传初级专业技术资格证附件信息
      savejuniorProDeptByFile() {
        if (this.fileDialog.juniorProQualAttachs.fileList.length === 0) {
          // Message.error({message: "请先选择上传的文件", showClose: true});
          this.saveAttachs(this.fileDialog.juniorProQualAttachs.cd);
          this.handleCommit();
          return;
        }
        let attachment = [];
        // this.loadingText="上传中"
        let start=this.fileDialog.juniorProQualAttachs.tableDataList.length - this.fileDialog.juniorProQualAttachs.fileList.length
        let end = this.fileDialog.juniorProQualAttachs.tableDataList.length
        //只需要上传新的数据即可
        for (let i= start ;i<end ;i++){
          attachment.push({
            attachmentName : this.fileDialog.juniorProQualAttachs.tableDataList[i].attachmentName,
            attachmentOriginalName : this.fileDialog.juniorProQualAttachs.tableDataList[i].attachmentOriginalName,
          })
        }
        //上传附件
        this.uploadFiles(attachment, this.fileDialog.juniorProQualAttachs.tableDataList, this.fileDialog.juniorProQualAttachs.cd)
      },

      //上传附件
      uploadFiles(attachment,updateAttachments,flag){
        let _this=this
        // 使用form表单的数据格式
        const paramsData = new FormData();

        let jsonData = {};
        if (flag == '001-001'){
          // 将上传文件数组依次添加到参数paramsData中
          this.fileDialog.practiceQualAttachs.fileList.forEach((it, index) => {
            paramsData.append(`file`, it.file);
          });
          jsonData = {
            token: cookie.getCookie("token"),
            data:{
              cd:_this.fileDialog.practiceQualAttachs.cd,
              attachment: attachment
            }
          }
        }else if(flag == '001-036'){
          // 将上传文件数组依次添加到参数paramsData中
          this.fileDialog.medicalLicAttachs.fileList.forEach((it, index) => {
            paramsData.append(`file`, it.file);
          });

          jsonData = {
            token: cookie.getCookie("token"),
            data:{
              cd:_this.fileDialog.medicalLicAttachs.cd,
              attachment: attachment
            }
          }
        }else if(flag == '001-037'){
          // 将上传文件数组依次添加到参数paramsData中
          this.fileDialog.juniorProQualAttachs.fileList.forEach((it, index) => {
            paramsData.append(`file`, it.file);
          });

          jsonData = {
            token: cookie.getCookie("token"),
            data:{
              cd:_this.fileDialog.juniorProQualAttachs.cd,
              attachment: attachment
            }
          }
        }

        // Message.info("附件上传可能需要几分钟,请耐心等待");
        //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
        paramsData.append('data', new Blob([JSON.stringify(jsonData)], {type: "application/json"}));
        // 表单数据和文件一起上传,调用后端接口
        this.fileFlag.uploadLoading = true
        http.post(window.config.api.baseUrl + '/eims-api/userInfo/attachment/add', paramsData).then(response => {
          if (response.data.code === '00000') {
            let attachment = response.data.data.attachment;
            if (flag == '001-001'){
              if (!this.form.practiceQualAttachs) {
                this.form.practiceQualAttachs = [];
              }
            }else if(flag == '001-036'){
              if (!this.form.medicalLicAttachs) {
                this.form.medicalLicAttachs = [];
              }
            }else if(flag == '001-037'){
              if (!this.form.juniorProQualAttachs) {
                this.form.juniorProQualAttachs = [];
              }
            }

            for (let i in attachment){
              let temp = {};
              temp.id = attachment[i].id;
              temp.code = attachment[i].code
              temp.attachmentName = attachment[i].attachmentName;
              temp.attachmentOriginalName = attachment[i].attachmentOriginalName;
              if (flag == '001-001'){
                this.fileDialog.practiceQualAttachs.tableDataList.push(temp)
                //清空原文件的数组
                this.fileDialog.practiceQualAttachs.fileList = []
              }else if (flag == '001-036'){
                this.fileDialog.medicalLicAttachs.tableDataList.push(temp)
                //清空原文件的数组
                this.fileDialog.medicalLicAttachs.fileList = []
              }else if (flag == '001-037'){
                this.fileDialog.juniorProQualAttachs.tableDataList.push(temp)
                //清空原文件的数组
                this.fileDialog.juniorProQualAttachs.fileList = []
              }
            }
            //最后一个上传附件，如果成功就跳转到保存信息
            if (flag == '001-001'){
              this.saveAttachs(flag)
              this.saveMedicalDeptByFile();
            }else if(flag == '001-036'){
              this.saveAttachs(flag)
              this.savejuniorProDeptByFile(flag);
            }else if (flag == '001-037') {
              this.saveAttachs(flag)
              this.handleCommit(flag);
            }

          }else {
            //如果后端抛出了异常 ,需要关闭加载动画
            this.setLoadingVisibleState(false)
          }
        }).finally(() => {
          // this.attachmentUploadState = true
          // this.dialog.isShow = false
          this.fileFlag.drawerVisible = false;
          this.fileFlag.uploadLoading = false;
        })
      },

      //点击查看按钮
      preViewAttachment(item,index,flag){
        //准备需要查看的附件的链接,然后显示或者下载附件
        let fullName=  item.attachmentOriginalName;

        //判断附件类型
        let tableDataList = [];
        let fileList = [];
        if(flag == '001-001'){
          tableDataList = this.fileDialog.practiceQualAttachs.tableDataList;
          fileList = this.fileDialog.practiceQualAttachs.fileList;
        }else if(flag == '001-036'){
          tableDataList = this.fileDialog.medicalLicAttachs.tableDataList;
          fileList = this.fileDialog.medicalLicAttachs.fileList;
        }else if(flag == '001-037'){
          tableDataList = this.fileDialog.juniorProQualAttachs.tableDataList;
          fileList = this.fileDialog.juniorProQualAttachs.fileList;
        }

        //如果不是图片的格式的附件,则使用上面这种预览方式
        if(!this.attachment.imagesType.includes(fullName.substring(fullName.lastIndexOf(".") + 1))){
          //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
          let file = fileList[index-(tableDataList.length-fileList.length)]
          if (file){
            //附件未上传预览
            this.handleView(file)
          }else{
            //附件已上传的预览
            this.handleView(tableDataList[index])
          }

          //如果是图片则使用这种预览方式
        }else{
          //生成附件的预览链接
          this.generateAttachmentsPath(tableDataList,index)
          if (  this.attachment.attachmentsLink.length !==0 ){
            //el-image组件的预览
            this.$refs.previewImg.showViewer = true;
          }else{
            //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
            this.handleView(fileList[index-(tableDataList.length-fileList.length)])
          }
        }
      },

      //将传来的附件生成附件的链接
      generateAttachmentsPath(attachments,index){
        let attachmentsLink=[]
        //将index这个文件放在第一个,给image组件使用的
        for (let i=index; i<attachments.length;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if (attachment.code !== undefined){
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+attachment.code);
            }
          }
        }
        if ( attachmentsLink.length === 0 ){
          this.attachment.attachmentsLink = []
          return
        }
        for (let i=0; i<index;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if(attachment.code !== undefined) {
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + attachment.code);
            }
          }
        }
        this.attachment.attachmentsLink=attachmentsLink
      },

      //准备需要查看的附件的链接,然后显示或者下载附件
      handleView(item){
        if (item.file){
          let fileType= item.file.name.substring(item.file.name.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.fileFlag.attaFileType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            elink.download = item.file.name;
          }
          elink.style.display = 'none';
          elink.target='_blank';
          // elink.href = URL.createObjectURL(new Blob([item.file.raw],{type:attaFileTypeElement}));
          elink.href = URL.createObjectURL(item.file);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          let fileType= item.attachmentOriginalName.substring(item.attachmentOriginalName.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.fileFlag.attaFileType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            http.get(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code,
              { responseType: "blob" }).then(response => {
              if (response){
                let attaFileDownTypeElement = this.fileFlag.attaFileDownType[fileType];
                elink.download = item.attachmentName;
                elink.style.display = 'none';
                elink.target='_blank';
                elink.href = URL.createObjectURL(new Blob([response.data],{type:attaFileDownTypeElement}));
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
              }
            }).catch(error =>{
              console.log(error)
            })
          }else {
            elink.style.display = 'none';
            elink.target='_blank'
            elink.href = window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code;
            // elink.href = URL.createObjectURL(new Blob([response],{type:attaFileTypeElement}));
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        }
      },

      //提交弹窗信息
      commitEimsUserBasic(){
        this.loadingText="保存中"
        this.setLoadingVisibleState(true)
        //先上传附件的信息
        this.savePracticeDeptByFile()
        this.attachmentUploadState = true
      },

      //设置动画加载是否显示
      setLoadingVisibleState(flag){
        this.formInfoSaveState = !flag
        this.attachmentUploadState= !flag
      },
    },

    created() {
      window.addEventListener('resize', this.getHeight);
      this.getHeight();
      this.getDepartments();
      if (this.$route.query.isSelf == "1") {
        this.editSelf = "1"
      }
      //数据回显到页面
      if (this.eimsUserInfoBase && this.eimsUserInfoBase.userId){
        this.form = this.eimsUserInfoBase;
        this.fileDialog.practiceQualAttachs.tableDataList = this.eimsUser.practiceQualAttachs;
        this.fileDialog.medicalLicAttachs.tableDataList = this.eimsUser.medicalLicAttachs;
        this.fileDialog.juniorProQualAttachs.tableDataList = this.eimsUser.juniorProQualAttachs;
        this.fileFlag.drawerVisible = true;
        this.fileFlag.updateFlag = false;
      }
      if (this.eimsUser && (this.eimsUser.userId || this.eimsUser.name || this.eimsUser.departmentId)) {
        this.form.userId = this.eimsUser.userId;
        this.form.name = this.eimsUser.name;
        this.form.majorDepartId = this.eimsUser.majorDepartId;
        this.form.practiceQualAttachs = this.eimsUser.practiceQualAttachs;
        this.form.medicalLicAttachs = this.eimsUser.medicalLicAttachs;
        this.form.juniorProQualAttachs = this.eimsUser.juniorProQualAttachs;
      }
    },

    destroyed() {
      let that = this;
      let eimsUser = {
        userId: that.form.userId,
        name: that.form.name,
        //这个是为了保存到数据库使用的
        majorDepartId: that.elementDeptId[that.elementDeptId.length - 1] || this.form.majorDepartId ,
        //这个是为了回显组件数据使用的
        elementDeptId: that.elementDeptId,
        practiceQualAttachs: that.form.practiceQualAttachs,
        medicalLicAttachs: that.form.medicalLicAttachs,
        juniorProQualAttachs: that.form.juniorProQualAttachs,
      };
      that.$store.dispatch("getBasicInfo", {"eimsUser": eimsUser, "eimsUserInfoBase": that.form});
      window.removeEventListener('resize', this.getHeight);
    },

    computed: {
      ...mapState({
        stateElementDeptId:state => state.elementDeptId,
        eimsUser: state => state.basicInfoModule.eimsUser,
        eimsUserInfoBase: state => state.basicInfoModule.eimsUserInfoBase,
        userUserId: state => state.userModule.userId,
        codesTree: state => state.codeDictModule.codesTree,
        response:state => state.memberAllInfoModule.response,
        eimsCodes : state => state.codeDictModule.eimsCodes,
      })
    }
  }
</script>

<style scoped>
  /deep/ .cab .is-horizontal{
    display: none;
  }
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden !important;
    top: auto !important;
  }

  .form_span{
    width: 100%;
    float: left;
    text-align: left;
  }

  /deep/ .el-image__error{
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/member/BasicUpdateInfo.vue